import { Button } from "@/components/Core/Button";
import { Input } from "@/components/Core/Input";
import { camelCaseToLower, RenderToast } from "@/helper/HelperFunction";
import { useState } from "react";
import ModalSkeleton from "../ModalSkeleton";
import classes from "./AddEditCategoryModal.module.css";

const AddEditCategoryModal = ({
  show,
  setShow,
  selectedItem,
  handleClick,
  modalLoading,
}) => {
  const [name, setName] = useState(selectedItem?.name || "");

  const handleSubmit = () => {
    const params = {
      ...(selectedItem && { categoryId: selectedItem?._id }),
      name,
    };
    for (const key in params) {
      if (!params[key]) {
        return RenderToast({
          type: "error",
          message: `${camelCaseToLower(key)} is required`,
        });
      }
    }

    handleClick(params);
  };

  return (
    <>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        header={selectedItem ? "Update Category" : "Add Category"}
        width="550px"
      >
        <div className={classes.mainWrapper}>
          <Input
            label="Category Name"
            value={name}
            setter={setName}
            placeholder="Enter Category Name"
          />
        </div>
        <div className={classes.buttonsContainer}>
          <Button
            label="Cancel"
            onClick={() => setShow(false)}
            disabled={modalLoading}
          />
          <Button
            label={modalLoading ? "Saving..." : "Save"}
            onClick={handleSubmit}
            disabled={modalLoading}
            variant="secondary"
          />
        </div>
      </ModalSkeleton>
    </>
  );
};

export default AddEditCategoryModal;
